import React from 'react';
import kohaImage from '../assets/images/koha_image2.png';
import { MyButton } from './ui/MyButton.js';
import BenefitsSection from './ui/BenefitsSection.js';
import { benefitsOfKoha } from '../constant.js';
import macbookImg from '../assets/images/macbook.png';
import { useNavigate } from "react-router-dom";
import image5 from '../assets/images/image5.png';
import image6 from '../assets/images/image6.png';
import ScrollAnimation from 'react-animate-on-scroll';
import cloudImg from '../assets/images/cloud.svg';
import cloudeImg1 from '../assets/images/cloud1.svg';

const ServicesKoha = () => {
    const navigate = useNavigate();
    return (
        <div className='animated_card '>
            <div className='sizedbox row g-2 gap-2 justify-content-between mt-5'>
                <div className='col-12 col-md-5'>
                    <div className="container" >
                        <div className="position-relative text-center">
                            <img
                                src={kohaImage}
                                alt="Laptop"
                                className="img-fluid"
                                style={{ maxWidth: "100%" }}
                            />
                            <div className='position-absolute' style={{ width: "40%", top: "0", marginTop: "10%", left: "-5%" }}>
                                <ScrollAnimation animateIn='fadeInLeft'
                                    animateOut='fadeOutLeft' duration="2" initiallyVisible="true">
                                    <img src={cloudeImg1} alt="Cloud 1" className="img-fluid" />
                                </ScrollAnimation>
                            </div>
                            <div className=' position-absolute' style={{ width: "30%", bottom: "0%", marginBottom: "15%", right: "20%" }}>
                                <ScrollAnimation animateIn='fadeInRight'
                                    animateOut='fadeOutRight' duration="2" initiallyVisible="true">
                                    <img
                                        src={cloudeImg1}
                                        alt="Cloud 2"
                                        className="img-fluid"
                                    />
                                </ScrollAnimation>
                            </div>

                        </div>
                    </div>
                    {/* <img src={kohaImage} alt='Koha' style={{ width: "100%", height: "auto", maxHeight: "500px" }}></img> */}
                </div>
                <div className='col-12 col-md-6'>
                    <h2 style={{ color: "var(--text-color)" }}>Hosted Koha LMS <br />
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}>On Cloud</span></h2>
                    <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px", marginBottom: "30px", marginTop: "30px" }}>
                        <span style={{ fontWeight: "700", fontSize: "22px", lineHeight: "30px" }}>"Your Reliable, Fully Managed Cloud-Based Library Management Solution"</span><br /><br />
                        At LibCloud, we offer a fully managed, cloud-based Koha solution designed to meet the diverse needs of libraries of all sizes. With our turnkey Koha packages, business associates can effortlessly provide clients with a robust library management system, allowing them to focus on driving sales. Our secure cloud hosting guarantees scalability, high performance, and reliability, so you can offer a seamless solution without the worry of technical complexities. Let LibCloud simplify the process, empowering you to focus on what matters most—growing your business. Trust LibCloud to be your partner in delivering efficient, cloud-hosted Koha solutions to libraries worldwide.</p>
                    <div className='mt-auto'>
                        <MyButton btntext="Contact Us" onClick={() => { navigate("/contact") }} />
                    </div>
                </div>
            </div>
            <div className='mt-3'>
                <BenefitsSection title="Why Choose LibCloud for Hosted Koha LMS?" list={benefitsOfKoha} />
            </div>
            <div className='d-flex justify-content-end' style={{ marginBottom: "-20%", paddingRight: "10%" }}>
                <img src={cloudImg} alt='Cloud' style={{ maxWidth: "50%", height: "auto" }}></img>
            </div>
            <div style={{ backgroundImage: "linear-gradient(0, #EBF1FD  0 50%, white 50% 100%)" }}>
                <div className="container" >
                    <div className="position-relative text-center">
                        <img
                            src={macbookImg}
                            alt="Laptop"
                            className="img-fluid"
                            style={{ maxWidth: "100%" }}
                        />
                        <div className='position-absolute' style={{ width: "25%", bottom: "0", marginBottom: "10%", left: "5%" }}>
                            <ScrollAnimation animateIn='fadeInLeft'
                                animateOut='fadeOutLeft' duration="2">
                                <img src={image5} alt="Custom OPAC Layout" className="img-fluid" />
                            </ScrollAnimation>
                        </div>
                        <div className=' position-absolute' style={{ width: "25%", bottom: "0%", marginBottom: "31%", right: "5%" }}>
                            <ScrollAnimation animateIn='fadeInRight'
                                animateOut='fadeOutRight' duration="2">
                                <img
                                    src={image6}
                                    alt="Pre-defined Reports"
                                    className="img-fluid"
                                />
                            </ScrollAnimation>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesKoha;